import { createFileRoute } from '@tanstack/react-router';

import { buildSeoHead, ROUTE_META } from '@src/corelib/seo';
import { DefaultLayout } from '@src/layout';
import ContactPage from '@src/pages/Contact';

export const Route = createFileRoute('/contact')({
  head: () => buildSeoHead({ path: '/contact', ...ROUTE_META['/contact'] }),
  component: ContactPageWithLayout,
});

function ContactPageWithLayout() {
  return (
    <DefaultLayout>
      <ContactPage />
    </DefaultLayout>
  );
}
